// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.session-container {
  background-color: white;
}

.session-container.horizontal.ui.grid {
  margin: 0px !important;
}

.session-container.horizontal .menu-column .item.new {
  padding: 0.78571429em 1.1em !important;
}

.session-container.horizontal .ui.vertical.menu .item > i.icon {
  margin: 0 0.35714286em 0 0 !important;
}

.session-container.horizontal .session-layout > .ui.divider {
  margin: 5px 0px 0px 0px;
}

.session-container.vertical {
  padding: 15px;
  display: flex;
  flex-direction: column;
}
.session-layout {
  flex: 100 100 auto;
  display: flex;
  overflow: hidden;
}

.session-container.horizontal .session-layout {
  flex-direction: column;
}

.session-container.vertical .menu-bar {
  justify-content: space-between;
  margin: 0px !important;
}

.session-container.vertical .menu-bar .content-left {
  width: 100%;
}

.session-container.vertical .menu-bar .close-button.item:before {
  background: none !important;
}

.session-container.vertical .menu-bar .close-button.item {
  box-shadow: none !important;
}

.session-container.vertical .menu-bar .content-left > .ui.dropdown {
  float: left;
}

.session-container.vertical .menu-bar .content-left > .ui.dropdown .menu {
  max-height: calc(100dvh - 140px);
  overflow-y: auto;
  overflow-x: hidden;
  max-width: calc(100vw - 30px);
}

.session-container.vertical .session-item .count.label {
  margin-left: 1em !important;
}

.session-container.vertical .session-header {
  display: flex;
  align-items: center;
  height: 100%;
}

.session-container.vertical .session-header > div {
  max-width: 90%; /* Hack, auto width won't work without "overflow: hidden", but that would prevent viewing the menu items  */
  padding: 0.82857143em 0.4285714em;
  line-height: 1.2;
}

.session-container.vertical .session-header > div:before {
  background: none !important;
}

.session-container.vertical .session-header > i {
  margin-left: 10px;
}

.session-container.vertical .session-header .ui.dropdown > i {
  margin: 0px 5px;
}

/* Fix a few inconsistencies between 'icon' and 'icons' classnames */
.session-container.horizontal .session-header .header > i,
.session-container.vertical .session-header > i {
  width: inherit !important;
  font-size: 1.5em;
}

.session-container.horizontal .session-header .ui.header {
  align-items: center;
}

.session-container.vertical .menu-bar {
  border-radius: 0px !important;
  padding-bottom: 0px;
}

.session-container,
.session-layout,
.session-container.horizontal .column {
  height: 100%;
}

.session-container.horizontal .column > div {
  max-height: 100%;
}

.session-container .session-item {
  overflow: hidden;
  display: flex !important;
  align-items: center;
  padding: 0.68571429em 0.92857143em !important;
  height: 35px;
}

.session-container .session-item .session-status {
  float: none !important;
  margin: 0 0.5em 0 0 !important;
}

.session-container .session-item span.name {
  overflow: hidden;
  flex: 1 1 100%;
  line-height: 1.2;
}

.session-container .session-status {
  margin-right: 5px;
  margin-top: 3px;
}

.session-container.horizontal .menu-column {
  display: flex !important;
  flex-direction: column;
  padding-right: 0px !important;
}

.session-container.horizontal .menu-column .menu {
  width: initial !important;
  overflow-y: auto;
  padding-top: 10px;
  flex: 1;
}

.session-container.horizontal .menu-column .session-item span.name,
.session-container .session-header .ui.dropdown .caption {
  overflow: hidden;
  white-space: nowrap;
}

.session-container .session-header .title .ui.dropdown {
  width: 100%;
}

.session-layout .sub.header {
  overflow: hidden;
}

.session-layout .sub.header img {
  vertical-align: text-top;
}

.session-footer .info-grid {
  margin-top: 7px !important;
  font-size: small;
  color: grey;
  display: flex;
  flex: 1;
  align-items: flex-end;
}

.session-footer .info-grid > div {
  flex: 1;
}

.session-footer .info-grid > div:last-child > div {
  float: right;
}

.session-footer .info-grid > div:only-child > div {
  float: inherit;
}

.session-footer .ui.checkbox {
  min-height: inherit !important;
}

.session-footer .divider {
  margin-top: 8px;
  margin-bottom: 0px;
}

/* New session layout */
.session.new {
  flex: 100 100 0%;
  display: flex;
  flex-direction: column;
  overflow-y: hidden;
  margin-top: 20px;
  padding: 1px;
}

.session.new .recents {
  flex: 100 100 0%;
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  overflow-y: hidden;
}

.session.new .recents .list {
  padding: 3px 5px;
  flex: 100 100 0%;
  overflow-y: auto;
  overflow-x: hidden;
}
`, "",{"version":3,"sources":["webpack://./src/routes/Sidebar/sessions.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc,EAAE,2GAA2G;EAC3H,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA,oEAAoE;AACpE;;EAEE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;;;EAGE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;EACnB,6CAA6C;EAC7C,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,OAAO;AACT;;AAEA;;EAEE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,OAAO;EACP,qBAAqB;AACvB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB","sourcesContent":[".session-container {\n  background-color: white;\n}\n\n.session-container.horizontal.ui.grid {\n  margin: 0px !important;\n}\n\n.session-container.horizontal .menu-column .item.new {\n  padding: 0.78571429em 1.1em !important;\n}\n\n.session-container.horizontal .ui.vertical.menu .item > i.icon {\n  margin: 0 0.35714286em 0 0 !important;\n}\n\n.session-container.horizontal .session-layout > .ui.divider {\n  margin: 5px 0px 0px 0px;\n}\n\n.session-container.vertical {\n  padding: 15px;\n  display: flex;\n  flex-direction: column;\n}\n.session-layout {\n  flex: 100 100 auto;\n  display: flex;\n  overflow: hidden;\n}\n\n.session-container.horizontal .session-layout {\n  flex-direction: column;\n}\n\n.session-container.vertical .menu-bar {\n  justify-content: space-between;\n  margin: 0px !important;\n}\n\n.session-container.vertical .menu-bar .content-left {\n  width: 100%;\n}\n\n.session-container.vertical .menu-bar .close-button.item:before {\n  background: none !important;\n}\n\n.session-container.vertical .menu-bar .close-button.item {\n  box-shadow: none !important;\n}\n\n.session-container.vertical .menu-bar .content-left > .ui.dropdown {\n  float: left;\n}\n\n.session-container.vertical .menu-bar .content-left > .ui.dropdown .menu {\n  max-height: calc(100dvh - 140px);\n  overflow-y: auto;\n  overflow-x: hidden;\n  max-width: calc(100vw - 30px);\n}\n\n.session-container.vertical .session-item .count.label {\n  margin-left: 1em !important;\n}\n\n.session-container.vertical .session-header {\n  display: flex;\n  align-items: center;\n  height: 100%;\n}\n\n.session-container.vertical .session-header > div {\n  max-width: 90%; /* Hack, auto width won't work without \"overflow: hidden\", but that would prevent viewing the menu items  */\n  padding: 0.82857143em 0.4285714em;\n  line-height: 1.2;\n}\n\n.session-container.vertical .session-header > div:before {\n  background: none !important;\n}\n\n.session-container.vertical .session-header > i {\n  margin-left: 10px;\n}\n\n.session-container.vertical .session-header .ui.dropdown > i {\n  margin: 0px 5px;\n}\n\n/* Fix a few inconsistencies between 'icon' and 'icons' classnames */\n.session-container.horizontal .session-header .header > i,\n.session-container.vertical .session-header > i {\n  width: inherit !important;\n  font-size: 1.5em;\n}\n\n.session-container.horizontal .session-header .ui.header {\n  align-items: center;\n}\n\n.session-container.vertical .menu-bar {\n  border-radius: 0px !important;\n  padding-bottom: 0px;\n}\n\n.session-container,\n.session-layout,\n.session-container.horizontal .column {\n  height: 100%;\n}\n\n.session-container.horizontal .column > div {\n  max-height: 100%;\n}\n\n.session-container .session-item {\n  overflow: hidden;\n  display: flex !important;\n  align-items: center;\n  padding: 0.68571429em 0.92857143em !important;\n  height: 35px;\n}\n\n.session-container .session-item .session-status {\n  float: none !important;\n  margin: 0 0.5em 0 0 !important;\n}\n\n.session-container .session-item span.name {\n  overflow: hidden;\n  flex: 1 1 100%;\n  line-height: 1.2;\n}\n\n.session-container .session-status {\n  margin-right: 5px;\n  margin-top: 3px;\n}\n\n.session-container.horizontal .menu-column {\n  display: flex !important;\n  flex-direction: column;\n  padding-right: 0px !important;\n}\n\n.session-container.horizontal .menu-column .menu {\n  width: initial !important;\n  overflow-y: auto;\n  padding-top: 10px;\n  flex: 1;\n}\n\n.session-container.horizontal .menu-column .session-item span.name,\n.session-container .session-header .ui.dropdown .caption {\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n.session-container .session-header .title .ui.dropdown {\n  width: 100%;\n}\n\n.session-layout .sub.header {\n  overflow: hidden;\n}\n\n.session-layout .sub.header img {\n  vertical-align: text-top;\n}\n\n.session-footer .info-grid {\n  margin-top: 7px !important;\n  font-size: small;\n  color: grey;\n  display: flex;\n  flex: 1;\n  align-items: flex-end;\n}\n\n.session-footer .info-grid > div {\n  flex: 1;\n}\n\n.session-footer .info-grid > div:last-child > div {\n  float: right;\n}\n\n.session-footer .info-grid > div:only-child > div {\n  float: inherit;\n}\n\n.session-footer .ui.checkbox {\n  min-height: inherit !important;\n}\n\n.session-footer .divider {\n  margin-top: 8px;\n  margin-bottom: 0px;\n}\n\n/* New session layout */\n.session.new {\n  flex: 100 100 0%;\n  display: flex;\n  flex-direction: column;\n  overflow-y: hidden;\n  margin-top: 20px;\n  padding: 1px;\n}\n\n.session.new .recents {\n  flex: 100 100 0%;\n  display: flex;\n  flex-direction: column;\n  margin-top: 20px;\n  overflow-y: hidden;\n}\n\n.session.new .recents .list {\n  padding: 3px 5px;\n  flex: 100 100 0%;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
